import firebase from "@firebase/app";
import $models from '@/models'
import { loadLanguageAsync, loadMomentLocaleAsync } from '@/i18n'
import moment from '@/moment-gp'

// import { instantiate_goal_from_template } from "@/models/goal/goalMeta/util";
// import userGoalInvitationModelDefinition from '@/models/user/userGoalInvitation'

// const $user = $models.user
// const $userSettings = $models.userSettings
// const $userStatus = $models.userStatus
// const $userPublic = $models.userPublic

// =============================================================================

export function user_update_online_status({ isOnline }) {
  return $models.userStatus.update( $models.user.defaultUserId, { isOnline } )
}

// -----------------------------------------------------------------------------
export function user_update_current_task({ goalId, taskId, taskDuration, taskRecordingStartedAt }) {
  // TODO
}

// -----------------------------------------------------------------------------
export function user_update_status_message({ statusMessage }) {
  return $models.userStatus.update( $models.user.defaultUserId, { statusMessage } )
}

// -----------------------------------------------------------------------------
export function user_update_settings( userPayload ) {
  return $models.userSettings.update( $models.user.defaultUserId, userPayload )
}

// -----------------------------------------------------------------------------
export function user_update_settings_by_prefix({ prefix, data }) {

  let payload = {}

  Object.keys(data).forEach(key => {
    payload[`${prefix}/${key}`] = data[key];
  });

  return this.user_update_settings( payload )
}

// -----------------------------------------------------------------------------
export function user_update_language({ language }) {

  // TODO: also update firebase auth language

  console.log("[i18n] Setting language to", language);

  loadMomentLocaleAsync(language).then((language) => {
    console.log("[i18n] Async load moment complete", language);
  });

  loadLanguageAsync(language).then((language) => {
    console.log("[i18n] Async load language complete", language);
  })

  // let updatedUserData = { 'settings.language': language };
  // return context.dispatch('user_update_public_profile', updatedUserData).then(() => {
  // })

  return user_update_settings({ 'settings/language': language }).then(() => {

    localStorage.setItem('language', language);
    console.log("[i18n] Language sucessfully written to DB and local storage");

  }).catch(() => {
    console.log("[i18n] Language not written");
  });
}

// -----------------------------------------------------------------------------
export function user_update_public_profile( userPayload ) {

  /*
  if ( 'FirstName' in userPayload || 'LastName' in userPayload ) {
    user_sync_public_cached(userPayload)
    user_sync_auth(...)
  }
  */
  // if (newUsername !== '') {
  //   this.dispatch('user/user_updateUsernameInStatus', { username: newUsername });
  // }

  return $models.userPublic.update( $models.user.defaultUserId, userPayload )
}

// -----------------------------------------------------------------------------
// export function user_update_public({ userPayload }) {
//   return this.$models.userPublic.update( $models.user.defaultUserId, userPayload )
// }

// -----------------------------------------------------------------------------
export function user_update_profile_picture({ profilePicUrl }) {

  // TODO: Also update all goals !!! - or remove cached pic completly

  let user = firebase.auth().currentUser;

  let pAuthUser = user.updateProfile({ profilePic: profilePicUrl })
  let pUserSettings = user_update_public_profile({ profilePic: profilePicUrl })

  return Promise.all([ pAuthUser, pUserSettings ])
}

// -----------------------------------------------------------------------------
/*
export function user_sync_public_cached({ prefix, data }) {
  console.warn("TODO");
}
*/

// -----------------------------------------------------------------------------

export function user_soft_delete(context) {
  let updatedUserData = {
    deleted: true,
    deleteDate: moment.currentTimeServer('REALTIMEDB')
  };
  return $models.userSettings.update( $models.user.defaultUserId, updatedUserData )
}

const DELETE_SECRET = 'LbkiN7EcQMMYqLwCHtb'
export function user_hard_delete({ secret, confirm }) {

  if ( secret !== DELETE_SECRET ) {
    // This is just a extra layer of protection against users calling
    // $api.user_hard_delete()
    throw new Error('Not allowed.')
  }

  if ( !confirm ) {
    throw new Error('Not allowed.');
  }

  var currentUserEmail = firebase.auth().currentUser.email;
  let currentUserId = firebase.auth().currentUser.uid;

  if ( confirm !== currentUserEmail ) {
    throw new Error('Not allowed. Confirm deletion with current email address');
  }

  return $models.userSettings.update(currentUserId, {
    clientWipeoutRequest: moment.currentTimeServer('REALTIMEDB')
  })

  /* return new Promise((resolve, reject) => {
    user.delete().then(() => {
      resolve();
    }).catch((error) => {
      reject(error);
    });
  }) */
}

// -----------------------------------------------------------------------------
/*
export function user_update_cached_status({ username }) {
  return $models.userStatus.update( $models.user.defaultUserId, { username} )
  // TODO: also profile pic
}
*/

// -----------------------------------------------------------------------------
/*
export function user_create_workspace_for_project({ projectId }) {
  // TODO
}

// -----------------------------------------------------------------------------
export function user_set_project_workspace_contact({ projectId, contactId }) {
  // TODO
}

// -----------------------------------------------------------------------------
export function user_update_project_workspace_contact_position({ projectId, contactId, posX, posY }) {
  // TODO
}

// -----------------------------------------------------------------------------
export function user_update_project_workspace_contact_show_finished_tasks({ projectId, showFinished }) {
  // TODO
}

// -----------------------------------------------------------------------------
export function user_update_project_workspace_contact_collapsed({ projectId, contactId, collapsed }) {
  // TODO
}

// -----------------------------------------------------------------------------
export function user_update_project_workspace_contact_visible({ projectId, contactId, visible }) {
  // TODO
}
*/
